import { useEffect, useState } from "react";
import { observer } from 'mobx-react';
import { useStores } from 'stores/index';

//@ts-ignore
import { Tab, useFilterParams } from '@microui/react-ui';
import Listing from "./Listing";

const Main = () => {
  const { params, setParams } = useFilterParams();
  const { clientStore } = useStores();
  const [search, setSearch] = useState(params?.keyword);
  const [tab, setTab] = useState('');
  const tablist = [
    {
      key: 'all',
      title: 'TẤT CẢ ỨNG DỤNG',
      component: <Listing />
    },
    {
      key: 'owner',
      title: 'ỨNG DỤNG CỦA TÔI',
      component: <Listing />
    }
  ];

  useEffect(() => {
    if (!params.tab) {
      setTab(tablist[0].key);
    } else {
      setTab(params.tab)
    }
    setSearch(params?.keyword ?? '')
  }, [params]);


  useEffect(() => {
    clientStore.getClients();
  }, []);

  return (
    <Tab
      handleSearch={(val) => {
        setParams({ ...params, keyword: val })
      }}
      searchValue={search}
      handleSearchChange={(val) => {
        setSearch(val)
      }}
      currentTabKey={tab}
      tabList={tablist}
      handleTabChange={(tab) => {
        setParams({ ...params, tab: tab.key });
        setTab(tab.key)
      }}
    />
  );
}

export default observer(Main);